import axios from './axios.service'

const method = 'products'

class ProductsService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios.get(`/${method}/${id}`)
      return response.data
    } catch (error) {
      return error
    }
  }

  async updateStatus(rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/status/${rowClicked.id}`,
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async delete(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async store(data) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}`,
        data
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async update(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/${id}`,
        data
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async updateOrder(data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/updateorder/order`,
        data: {
          data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async getCategories(queryData) {
    try {
      const response = await axios.get('product-categories', {
        params: { ...queryData }
      })

      return response.data
    } catch (error) {
      return error
    }
  }

  async getSubCategories(queryData) {
    try {
      const response = await axios.get('product-subcategories', {
        params: { ...queryData }
      })

      return response.data
    } catch (error) {
      return error
    }
  }

  async newsProducts(queryData) {
    try {
      const response = await axios.get('/news-products', {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }
}

export default new ProductsService()
